import {
  Button,
  FormControlLabel,
  Grid,
  Modal,
  Paper,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { Component } from "react";

// import AutocompleteInput from './AutocompleteInput';

//Multiselect
import MultiSelect from "../../../components/MultiSelect";
//service
import NotificationGroups from "../../../tools/NotificationGroups";
import UserService from "../../../tools/UserService";

//msgs
import { connect } from "react-redux";
import { msgSimple } from "../../../actions/snackbarActions";

//SweetAlert
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

class ModalNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: "",
      open: "",
      openMenu: false,
      loading: false,
      users: [],
      list: [],
      text: "",
      profiles: [],
      anchorEl: false,
      group: {
        id: "new",
        name: "",
        active: true,
        users: [],
      },
    };
  }

  componentWillMount() {
    UserService.get(null, null, 1, null, true).then(async (response) => {
      if (response.ok) {
        this.setState({
          users: await this._handleIdMultiSelect(response.response),
        });
      }
    });
  }

  returnLetter(name) {
    if (name) {
      let substring = name;
      let index = name.indexOf(" ");
      substring = substring.slice(0, 1);
      if (index !== -1)
        substring = substring.concat(name.slice(index + 1, index + 2));
      return substring;
    }
  }

  returnColor(profile) {
    switch (profile) {
      case "ADM":
        return "red";
      case "GER":
        return "green";
      case "MEC":
        return "yellow";
      case "PLT":
        return "blue";
      case "ARM":
        return "brown";
      case "DIR":
        return "orange";
      default:
        return "gray";
    }
  }

  _handleIdMultiSelect = async (value) => {
    if (value) {
      return await value.map((element) => {
        let label = [];
        label = label.concat(
          element.Sector.name,
          " - ",
          (element.first_name ? element.first_name : "") +
            " " +
            (element.last_name ? element.last_name : "")
        );
        return { value: element.id, label: label };
      });
    }
    return null;
  };

  onRender = async () => {
    if (this.props.id !== "new") {
      NotificationGroups.getById(this.props.id).then(async (response) => {
        if (response.ok) {
          // this.setState({ users: await this._handleIdMultiSelect(response.response) })
          await this.setState({
            group: {
              ...response.response,
              users: await this._handleIdMultiSelect(response.response.users),
            },
          });
        }
      });
    } else if (this.props.id === "new") {
      this.setState({
        group: {
          id: "new",
          name: "",
          active: true,
          users: [],
        },
      });
    }
  };

  handleSave = (item) => {
    Swal.fire({
      title:
        "<strong>Deseja realmente salvar as alterações realizadas?</strong>",
      type: "info",
      // html:'',
      customClass: "{ z-index: 1000000 }",
      customContainerClass: "{ z-index: 100000 }",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Salvar',
      confirmButtonAriaLabel: "Salvar",
      cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
      cancelButtonAriaLabel: "Cancelar",
    }).then((result) => {
      if (!!result.value) {
        if (item.id === "new") {
          delete item.id;
          item.users = item.users.map((el) => {
            return el.value;
          });
          NotificationGroups.create(item).then((result) => {
            if (result.ok) {
              this.props.closeModal({});
              this.props.refresh();
              this.props.msgSimple(item.name + " criado com sucesso.");
            } else {
              item.id = "new";
              this.props.msgSimple('Erro ao criar "' + item.name + '"');
              // this.props.closeModal({})
            }
          });
        } else {
          item.users = item.users.map((el) => {
            return el.value;
          });
          NotificationGroups.update(item.id, item).then((result) => {
            if (result.ok) {
              this.props.closeModal({});
              this.props.refresh();
              this.props.msgSimple(item.name + " atualizado com sucesso.");
            } else {
              this.props.msgSimple(
                'Erro ao atualizar "' + item.name + '"',
                "TENTAR NOVAMENTE"
              );
            }
          });
        }
      } else
        return MySwal.fire({
          title: "<p>Operação cancelada!</p>",
          type: "error",
        });
    });
  };

  render() {
    return (
      <Modal
        open={this.props.openModal}
        onRendered={this.onRender}
        onClose={this.onClose}
      >
        <Grid
          item
          style={{ height: "100%", overflowX: "auto" }}
          justify="center"
          alignItems="center"
          container
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
        >
          <Grid item container xs={12} sm={6} md={6} lg={6} xl={4}>
            <Paper style={{ height: "100%", width: "100%", padding: 20 }}>
              <Grid container>
                <Grid
                  style={{ height: "10%" }}
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                >
                  {this.props.id === "new"
                    ? "Novo Grupo de notificação"
                    : "Editar Grupo de notificação"}
                </Grid>
                <Grid
                  style={{ height: "25%" }}
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                >
                  <Typography
                    style={{ marginTop: 14, marginRight: 10 }}
                    variant="subheading"
                    id="modal-title"
                  >
                    Ativo:
                  </Typography>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.group.active}
                        color="primary"
                        onChange={(event) => {
                          let { group } = this.state;
                          this.setState({
                            group: { ...group, active: event.target.checked },
                          });
                        }}
                      />
                    }
                  />
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={{ padding: 0, margin: 0 }}
                >
                  <TextField
                    label="Nome"
                    required
                    style={{ width: "100%" }}
                    value={this.state.group.name}
                    margin="normal"
                    onChange={(event) => {
                      let { group } = this.state;
                      this.setState({
                        group: { ...group, name: event.target.value },
                      });
                    }}
                  />
                </Grid>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  style={{
                    height: "40%",
                    padding: 0,
                    margin: 0,
                    marginBottom: 10,
                    marginTop: 10,
                  }}
                >
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <MultiSelect
                      value={this.state.group.users}
                      suggestions={this.state.users}
                      isPax={{
                        isPax: false,
                        openPaxDialog: this.openPaxDialog,
                      }}
                      placeholder="Selecione os Usuários"
                      label="Adicionar ao Grupo"
                      onChange={(value) => {
                        let { group } = this.state;
                        this.setState({ group: { ...group, users: value } });
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  item
                  justify="flex-end"
                  container
                  style={{ height: "10%", margin: 20 }}
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                >
                  <Button
                    color="primary"
                    onClick={() => {
                      if (this.state.group.name !== "")
                        this.handleSave(this.state.group);
                      else
                        this.props.msgSimple(
                          "Preencha os campos obrigatórios."
                        );
                    }}
                  >
                    Salvar
                  </Button>
                  <Button color="secondary" onClick={() => this.props.func()}>
                    Cancelar
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  msgSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalNotifications);



// WEBPACK FOOTER //
// ./src/routes/settings/notificationgroups/Modal.js